// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"appWrapper__36kLv"};